import React, { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { setLocalStorage } from "../../utils";
import { stripShopifyAuthParamsFromUrl } from "../../utils/shopifyBookingBootstrap";

/**
 * OAuth / Shopify redirect handoff: store JWT then continue into booking.
 */
export default function ShopifyAuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { stylistcode } = useParams();

  useEffect(() => {
    const accessToken = params.get("access_token");
    const serviceId = params.get("service_id") || "";

    if (accessToken) {
      setLocalStorage("access_token", accessToken);
    }

    stripShopifyAuthParamsFromUrl();

    const query = serviceId ? `?service_id=${encodeURIComponent(serviceId)}` : "";
    navigate(`/${stylistcode || ""}${query}`, { replace: true });
  }, [navigate, params, stylistcode]);

  return null;
}
